import React, { useState, useMemo, useEffect } from 'react'
import Image from 'next/image'
import Link from 'next/link'

import styled from '@emotion/styled'
import axios from 'axios'
import ReactHtmlParser from 'react-html-parser'
import { getCookie } from 'cookies-next'
import { useRouter } from 'next/router'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'next-i18next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'

import {
  getFrontLiveEvent,
  postFrontCart,
  postFrontCartAllDelete,
  postFrontCartOption,
  postFrontCartTotal,
} from 'api'
import { nameToMasking, promotionBanner, switchReview } from 'lib'
import { DEFAULT_LANG } from 'constants/lang'
import { setCart } from 'store/cart'
import Header from 'components/Header'
import { BLUR, HOST, IMAGE, TAIL } from 'constants/image'
import Star from 'components/common/icon/Star'
import OtaButton from 'components/StoreSection/OtaButton'
import Footer from 'components/TourSection/Footer'
import Custom404 from 'pages/404'

const TourId = ({
  channel,
  initialStore,
  initialPromotions,
  initialProducts: stores,
  intialEvents,
}) => {
  if (initialStore.category !== 'tour') return <Custom404 />

  const {
    t,
    i18n: { language: lang },
  } = useTranslation()
  const router = useRouter()

  const dispatch = useDispatch()
  const token = useSelector((state) => state.auth.token)
  const { count, store: store_id } = useSelector((state) => state.cart)

  const {
    translate_name,
    store_image,
    location_translate_name2,
    location_translate_name3,
    rti_star,
    show_cnt,
    translate_address,
    telephone,
    translate_optime,
    translate_description,
    translate_etc,
    name,
    translate_branch_name,
    latitude,
    longitude,
    id,
    translate_address_road,
    status,
  } = initialStore

  const [isClient, setIsClient] = useState(false)
  useEffect(() => {
    setIsClient(true)
  }, [])

  const [amount, setAmount] = useState(() => {
    let obj = {}
    stores.map((store) =>
      store.options.map(
        (option) => (obj[`${store.id}_${option.option_id}`] = 0)
      )
    )
    return obj
  })
  const sumAmount = useMemo(() => {
    const values = Object.values(amount)

    let sum = 0
    values.forEach((item) => (sum += item))

    return sum
  }, [amount])

  const [events, setEvents] = useState(intialEvents)
  const [offset, setOffset] = useState(1)

  const minusHandler = (product_id, option_id) => {
    const key = `${product_id}_${option_id}`
    const value = amount[key]

    if (value === 0) return
    setAmount({ ...amount, [key]: value - 1 })
  }

  const plusHandler = (product_id, option_id) => {
    const key = `${product_id}_${option_id}`
    const value = amount[key]
    setAmount({ ...amount, [key]: value + 1 })
  }

  const searchKeyword = encodeURIComponent(`${name}${translate_branch_name}`)
  const reviews = [
    {
      name: 'Google',
      link: `https://www.google.com/search?q=${searchKeyword}&sxsrf=ALiCzsbmQJ7QykDtW8md9xxoQKePYT5wCA%3A1656584302771&source=hp&ei=bni9YveTLJH3-Qa-y7ngBw&iflsig=AJiK0e8AAAAAYr2GfppF8oBM0bKP1d9l2IH0loXVhmkG&ved=0ahUKEwj3gp63-dT4AhWRe94KHb5lDnwQ4dUDCAk&uact=5&oq=%EA%B3%B0%EA%B5%AD%EC%8B%9C%EC%A7%91&gs_lcp=Cgdnd3Mtd2l6EAMyCwguEIAEEMcBEK8BMgUIABCABDIFCAAQgAQyCwguEIAEEMcBEK8BMgQIABAeMgQIABAeMgYIABAeEA8yBAgAEB4yBAgAEB4yBggAEB4QDzoECCMQJzoLCAAQgAQQsQMQgwE6BAguEAM6BAgAEAM6BQguEIAEOhEILhCABBCxAxCDARDHARCvAToICAAQgAQQsQM6CAguEIAEELEDOgsILhCABBCxAxDUAlAAWO4IYIcKaAJwAHgCgAF-iAGpCZIBBDEuMTCYAQCgAQE&sclient=gws-wiz`,
    },
    {
      name: 'Naver',
      link: `https://search.naver.com/search.naver?where=nexearch&sm=top_hty&fbm=0&ie=utf8&query=${searchKeyword}`,
    },
  ]

  const moreButtonHandler = async () => {
    await getFrontLiveEvent({
      s_lang: lang,
      s_store_id: id,
      offset: offset + 1,
    })
      .then((res) => {
        if (res.status === 'success') {
          let arr = [...events]
          res.data.map((item) => arr.push(item))

          setEvents(arr)
          setOffset((prev) => prev + 1)
        }
      })
      .catch((err) => console.log(err))
  }

  const cartHandler = async () => {
    // 선택된 티켓 0개면 리턴
    if (sumAmount === 0) return

    // 토큰 있는지 체크
    if (!token) {
      const ok = window.confirm('로그인 페이지로 이동하시겠습니까?')
      if (ok) {
        sessionStorage.setItem('prevPath', router.asPath)
        return router.push('/signin')
      } else return
    }

    // 값 있는 옵션만 추출
    const selected = Object.entries(amount).filter((item) => item[1] > 0)

    // 기존 카트와 같은 상점인지 체크했는지 여부
    let checked = false
    const isSame = id === store_id

    if (store_id && !isSame) {
      const ok = window.confirm(t('cart:remove_all_alert'))
      if (ok) {
        checked = true
        await postFrontCartAllDelete(token)
      }
    } else checked = true

    // 장바구니 추가 로직
    if (checked) {
      selected.map(async (item, index) => {
        const product_id = item[0].split('_')[0]
        const product_option_id = item[0].split('_')[1]
        const quantity = item[1]

        // 리덕스 장바구니 수정
        if (!isSame) {
          // 기존 카트와 다른 상점일 경우 로직 : redux에 새로운 장바구니 정보 세팅
          dispatch(
            setCart({
              count: sumAmount,
              store: id,
              is_package: false,
            })
          )
        } else {
          // 기존 카트와 같은 상점일 경우 로직 : redux에 갯수만 업데이트
          dispatch(
            setCart({
              count: count + sumAmount,
              store: store_id,
              is_package: false,
            })
          )
        }

        // API 호출
        setTimeout(async () => {
          await postFrontCart({
            token,
            product_id,
            quantity,
          }).then(async (res) => {
            if (res.status === 'success') {
              const cart_id = res.data.id

              // 카트 옵션 추가 API 호출
              await postFrontCartOption({
                cart_id,
                product_option_id,
                token,
              })

              // 채널 저장
              await postFrontCartTotal({
                token,
                s_channel: channel,
              })
            }

            // 장바구니로 이동할지 결정
            const ok = window.confirm('Would you like to go to cart?')
            if (ok) router.push('/cart')
          })
        }, [500 * index])
      })
    }
  }

  return (
    <>
      <Header title={translate_name} />

      <Image
        src={store_image ? `${HOST}${store_image}${TAIL}` : BLUR}
        alt=""
        width={0}
        height={0}
        sizes="100%"
        style={{
          width: '100%',
          height: 300,
          objectFit: 'cover',
          padding: '0 16px',
        }}
      />

      <Container>
        {initialPromotions.length > 0 &&
          initialPromotions.map((item) => (
            <Promotion key={item.promotion_id}>
              <p className="promotion-name">
                {!item.translate_name || item.translate_name === ''
                  ? item.name
                  : item.translate_name}
              </p>
              {promotionBanner(item, lang)}
            </Promotion>
          ))}

        <StoreInfo>
          <ul>
            <li>
              <Name>{translate_name}</Name>
            </li>

            <li>
              <p>
                {location_translate_name2} / {location_translate_name3}
              </p>
            </li>

            <li style={{ display: 'flex' }}>
              <Star />
              <p>{rti_star ?? '0.0'}</p>
              <p>({show_cnt ?? 0})</p>
            </li>

            <li style={{ display: 'flex' }}>
              <Image src={'/icon/place.svg'} alt="" width={18} height={18} />
              <p>{translate_address}</p>
            </li>

            <li>
              <Image src={'/icon/phone.svg'} alt="" width={18} height={18} />
              <p>{telephone}</p>
            </li>

            {translate_optime && (
              <li>
                <Image src={'/watch.svg'} alt="" width={18} height={18} />
                <p>{ReactHtmlParser(translate_optime)}</p>
              </li>
            )}
          </ul>
        </StoreInfo>

        <ProductInfo>
          <ul>
            {stores.map((store) =>
              store.options.map((option) => (
                <li key={`${store.id}_${option.option_id}`}>
                  <p>
                    {ReactHtmlParser(store.translate_name)}{' '}
                    {option.translate_name}
                  </p>
                  <p>{ReactHtmlParser(store.translate_description)}</p>

                  {
                    <h4>
                      {parseInt(option.option_price).toLocaleString('ko-kr')}
                      <span> {store.currency}</span>
                    </h4>
                  }
                  <AmountSpinner>
                    <Button
                      onClick={() => minusHandler(store.id, option.option_id)}
                    >
                      <Image
                        src={`${IMAGE}/asset/image/minus_circle_black.svg`}
                        alt=""
                        width={36}
                        height={36}
                      />
                    </Button>
                    <p>{amount[`${store.id}_${option.option_id}`]}</p>
                    <Button
                      onClick={() => plusHandler(store.id, option.option_id)}
                    >
                      <Image
                        src={`${IMAGE}/asset/image/plus_circle_black.svg`}
                        alt=""
                        width={36}
                        height={36}
                      />
                    </Button>
                  </AmountSpinner>
                </li>
              ))
            )}
          </ul>
        </ProductInfo>

        <Description>
          {isClient && ReactHtmlParser(translate_description)}
          {isClient && ReactHtmlParser(translate_etc)}
        </Description>

        <Etc>
          <h4>Revies & Images</h4>
          <GridBox>
            {reviews.map((item) => (
              <OtaButton key={item.name} name={item.name} link={item.link} />
            ))}
          </GridBox>

          <h4>{t('store:store_location')}</h4>
          <p>{translate_address_road}</p>
          <Link
            href={`https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`}
            target="_blank"
          >
            <Image
              src={`https://maps.googleapis.com/maps/api/staticmap?language=ko&center=${latitude},${longitude}&zoom=18&size=1000x250&maptype=roadmap&markers=color:red%7C${latitude},${longitude}&key=${process.env.NEXT_PUBLIC_GOOGLE_MAP_KEY}`}
              alt=""
              width={0}
              height={0}
              sizes="100%"
              style={{
                width: '100%',
                height: 180,
                border: '1px solid rgba(0,0,0,0.1)',
                marginTop: 10,
              }}
            />
          </Link>
        </Etc>

        <LiveEvent>
          <h4>History</h4>
          <ul>
            {events.map((item, index) => (
              <li key={index}>
                <div className="flex-container">
                  <Image
                    src={
                      item.ip2nation_code
                        ? `${IMAGE}/asset/image/flags/1x1/${item.ip2nation_code}.svg`
                        : `${IMAGE}/asset/image/error_img.png`
                    }
                    alt=""
                    width={40}
                    height={40}
                    style={{
                      borderRadius: '50%',
                      backgroundColor: '#eee',
                      border: '1px solid #eee',
                    }}
                  />
                  <div className="profile">
                    <p className="name ellipsis">
                      {nameToMasking(item.user_name) ?? 'Guest'}
                    </p>
                    <p className="date">{item.created_at_utc} (UTC)</p>
                  </div>
                </div>
                <div className="event">{switchReview(item, lang)}</div>
              </li>
            ))}
          </ul>
          {offset && (
            <MoreButton onClick={() => moreButtonHandler()}>
              {t('more')}
            </MoreButton>
          )}
        </LiveEvent>
      </Container>

      <Footer
        id={id}
        description={t('cart:add_2').replace('N', sumAmount)}
        onClick={cartHandler}
        status={status === 'normal'}
      />
    </>
  )
}

export default TourId

export const getServerSideProps = async (ctx) => {
  const { id } = ctx.query

  const initialLang =
    ctx.locale === 'zh-cn' ? 'zh-Hans' : getCookie('lang', ctx) || DEFAULT_LANG

  const store = await axios
    .get(`${process.env.NEXT_PUBLIC_API_HOST}/front/store/${id}`, {
      params: { s_lang: initialLang },
    })
    .then((res) => res.data)
    .catch((err) => err)

  const products = await axios
    .get(`${process.env.NEXT_PUBLIC_API_HOST}/front/product`, {
      params: {
        s_lang: initialLang,
        s_store_id: id,
        s_order1: 'T10.sorting',
        s_order2: 'desc',
        limit: 300,
      },
    })
    .then((res) => res.data.data)
    .catch((err) => err)

  const events = await axios
    .get(`${process.env.NEXT_PUBLIC_API_HOST}/front/live-event`, {
      params: {
        s_lang: initialLang,
        s_store_id: id,
        s_orde1: 'created_at_utc',
        s_order2: 1,
      },
    })
    .then((res) => res.data.data)
    .catch((err) => err)

  return {
    props: {
      initialStore: store.data,
      initialPromotions: store.promotions,
      initialProducts: products,
      intialEvents: events,
      ...(await serverSideTranslations(ctx.locale, [
        'common',
        'store',
        'cart',
      ])),
    },
  }
}

const Container = styled.main`
  padding: 0 16px 72px 16px;
`

const StoreInfo = styled.section`
  padding-top: 16px;

  li {
    display: flex;
    align-items: center;
    margin-top: 10px;
  }

  li:last-child,
  li:nth-last-of-type() {
    align-items: flex-start;
  }

  li img {
    margin-right: 5px;
    margin-top: 2px;
  }

  li p {
    font-size: 14px;
    color: #777;
    font-weight: 300;
  }
`

const Promotion = styled.div`
  border: 2px dashed #ddd;
  border-radius: 5px;
  padding: 15px 25px 15px 25px;
  margin-top: 10px;

  .promotion-name {
    font-size: 18px;
    font-weight: 800;
  }

  .discount {
    font-size: 18px;
    color: red;
    font-weight: 900;
  }

  p {
    font-size: 14px;
  }
`

const Name = styled.h1`
  font-size: 20px;
  font-weight: 700;
`

const ProductInfo = styled.section`
  background-color: #f4f4f4;
  padding: 20px;
  margin-top: 32px;

  li {
    background-color: white;
    margin-bottom: 20px;
    padding: 16px;
  }

  li:last-of-type {
    margin-bottom: 0;
  }

  li p:nth-of-type(2) {
    color: #666;
    font-size: 14px;
    font-weight: 300;
    margin-top: 16px;
  }

  h4 {
    text-align: right;
    font-size: 24px;
    font-weight: 700;
  }

  h4 span {
    font-size: 14px;
    color: #666;
  }
`

const AmountSpinner = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 10px;

  p {
    font-size: 20px;
    font-weight: 600;
    line-height: 36px;
    padding: 0 16px;
  }
`

const Button = styled.button`
  height: 36px;
  background: none;
  border: none;
`

const Description = styled.section`
  width: 100%;
  margin-top: 32px;

  img {
    width: 100% !important;
    object-fit: cover;
  }

  p {
    color: #666;
    font-weight: 300;
    margin-bottom: 16px;
  }
`

const GridBox = styled.div`
  display: grid;
  grid-template-columns: 50% 50%;
  grid-gap: 8px;
  margin-bottom: 16px;

  div {
    width: 100%;
    border: 1px solid #ddd;
  }

  a {
    font-weight: 700;
    color: #333;
  }
`

const Etc = styled.section`
  margin-top: 32px;

  h4 {
    margin-bottom: 16px;
  }

  p {
    font-size: 14px;
    color: #666;
    font-weight: 300;
  }
`

const LiveEvent = styled.section`
  margin-top: 32px;

  h4 {
    font-size: 16px;
    font-weight: 600;
    color: #121212;
    margin-bottom: 5px;
  }

  li {
    border-bottom: 1px solid #eee;
    padding: 16px 0;
  }

  li:last-child {
    border-bottom: none;
  }

  .flex-container {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }

  .profile {
    margin-left: 16px;
    width: calc(100% - 50px);
  }

  .name {
    font-size: 16px;
    font-weight: 600;
  }

  .date {
    color: #777;
    font-size: 12px;
    font-weight: 300;
  }

  .event p {
    font-size: 14px;
    font-weight: 300;
    color: #777;
  }

  .emphasize {
    color: red;
    font-weight: 700;
  }
`

const MoreButton = styled.div`
  width: 100%;
  height: 50px;
  line-height: 50px;
  text-align: center;
  border: 1px solid #ddd;
  color: #777;
  cursor: pointer;
`
